import { ResourceRequestHelperInfo } from "./resourceRequest";

export default function ResourceRequestEntries() {
  return (
    <ResourceRequestHelperInfo />
  );
}
